import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=c38089ee&scoped=true"
import script from "./notification.vue?vue&type=script&lang=ts"
export * from "./notification.vue?vue&type=script&lang=ts"
import style0 from "./notification.vue?vue&type=style&index=0&id=c38089ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38089ee",
  null
  
)

export default component.exports